import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames";
// import { Card, CardBody, Row, Col, Input, Button, Label } from 'reactstrap'
import Skeleton from "react-loading-skeleton";
import {
  Video,
  X,
  Edit,
  Package,
  Trello,
  Feather,
  Users,
  Eye,
  Box,
  Youtube,
  Globe,
  Tag,
  Volume2,
  Image,
  Film,
  Activity,
} from "react-feather";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardText,
  Label,
  Input,
  Button,
} from "reactstrap";

import Filter from "./Filter";
import FiltersSwitch from "./FiltersSwitch";
import { filterNames } from "../../constants";
import Sort from "./Sort";
import DateSelect from "../DateSelect";
import PerfectScrollbar from "react-perfect-scrollbar";
// ** Styles
import "@styles/react/libs/noui-slider/noui-slider.scss";
import "./Filters.scss";
import DateRange from "../DateRange";
import { doResetFiltersInfluencers } from "../../Pages/Influencer/influencer_actions";
import { doResetFiltersVideos } from "../../Pages/Video/VideoActions";
import { doResetFiltersProducts } from "../../Pages/Product/productActions";

import "react-loading-skeleton/dist/skeleton.css";

import mixpanel from "mixpanel-browser";
import {
  MIXPANEL_VIDEOS_PAGE,
  MIXPANEL_PRODUCTS_PAGE,
  MIXPANEL_CREATORS_PAGE,
} from "../../mixpanel/mixpanel_constants";

const proFilters = [
  "note",
  "scene",
  "category",
  "product",
  "brand_safety",
  "demographic",
  "sponsored",
];

const IconByImage = ({ path, size }) => {
  return (
    <img
      src={require(`@src/assets/images/vyrill/${path}`).default}
      width={size}
    />
  );
};

const filterIcons = {
  views: <Eye size={16} />,
  note: <Edit size={16} />,
  topic: <Tag size={16} />,
  scene: <Image size={16} />,
  pov: <Feather size={16} />,
  country: <Globe size={16} />,
  language: <Globe size={16} />,
  videos: <Youtube size={16} />,
  product: <Package size={16} />,
  influencer: <Video size={16} />,
  category: <Package size={16} />,
  influencer: <Video size={16} />,
  platform: <Youtube size={16} />,
  demographic: <Users size={16} />,
  subscribers: <Users size={16} />,
  audio_labels: <Volume2 size={16} />,
  competitor_brands: <Video size={16} />,
  brand: <IconByImage path="icons/brand-icon.svg" size={14} />,
  sponsored: <IconByImage path="icons/contract-icon.svg" size={15} />,
  brand_safety: <IconByImage path="icons/brand-safety-icon.svg" size={14} />,

  //Sentiments Report Icons
  video_stats: <Activity size={14} />,
  video_type: <Film size={14} />,
  time_published: <IconByImage path="icons/upload-time-icon.png" size={16} />,
  creator_demographics: <Users size={16} />,
  creators: <Video size={16} />,
  campaigns: <IconByImage path="icons/campaign.svg" size={18} />,
  products: <Package size={16} />,
  competitor_products: <Package size={16} />,
};

const Filters = ({
  selectedFilters,
  filters,
  updateFilters,
  openFilter,
  changeFilter,
  updateSort,
  sort,
  desc,
  updateParams,
  updateSubFilters,
  updateParentTopics,
  dates,
  updateDates,
  trending,
  updateTrending,
  sortOptions,
  loading,
  date,
  updateDate,
  dateSelect,
  validEmail,
  updateValidEmail,
  vyrillVerified,
  updateVyrillVerified,
  basic,
  topicFilters,
  submitButton,
  applyFilters,
  submitStatus,
  filtersLoading,
  page,
  sentimentReportIcons,
  filtersHeight,
  isSeperateScroll,
  indexRedesign,
}) => {
  const dispatch = useDispatch();
  const handleClearFilters = () => {
    switch (page) {
      case "influencers":
        mixpanel.track(MIXPANEL_CREATORS_PAGE.CLEAR_ALL_FILTERS);
        dispatch(doResetFiltersInfluencers());
        if (date) {
          dispatch(updateParams({ date: null }));
        }
        break;
      case "videos":
        mixpanel.track(MIXPANEL_VIDEOS_PAGE.CLEAR_ALL_FILTERS);
        dispatch(doResetFiltersVideos());
        break;
      case "products":
        mixpanel.track(MIXPANEL_PRODUCTS_PAGE.CLEAR_ALL_FILTERS);
        dispatch(doResetFiltersProducts());
        break;
      default:
        break;
    }
  };

  const removedFilters = ["influencer", "pov", "creators"];

  const showCampaignHeader = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignHeader
  );
  const hiddenFiltersWhenCampaignHeader = ["note", "views", "sponsored"];

  return (
    <div
      className="sidebar-detached sidebar-right"
      style={
        // isSeperateScroll
        //   ? {
        //       height: "inherit",
        //       backgroundColor: "white",
        //       borderTopLeftRadius: "20px",
        //     }
        //   : indexRedesign
        { backgroundColor: "white" }
        // : {}
      }
    >
      <div
        className={`sidebar ${indexRedesign && "p-1"}`}
        style={
          isSeperateScroll
            ? {
                borderLeft: "0.5px solid #bcbcc0",
                borderTop: "0.5px solid #bcbcc0",
                borderTopLeftRadius: "20px",
                padding: "15px 0px 0px 10px",
              }
            : {}
        }
      >
        <div className="d-flex justify-content-between mb-1">
          <div>
            <h5>
              <strong>Filters</strong>
            </h5>
          </div>
          <div>
            {page !== "reports" && (
              <h5 onClick={handleClearFilters}>
                <span style={{ color: "#783AD0" }} role="button">
                  Clear All Filters
                </span>
              </h5>
            )}
          </div>
        </div>
        <PerfectScrollbar
          className="main-menu-content pe-1"
          options={{ wheelPropagation: true }}
          // onScrollY={(container) => scrollMenu(container)}
          style={{ height: filtersHeight, minScrollbarLength: 0 }}
        >
          <div
            className={classnames("sidebar-shop", {
              show: true,
            })}
            style={{ width: "auto" }}
          >
            <div className="p-0 pb-5">
              {filtersLoading ? (
                [1, 2, 3, 4].map((x) => {
                  return <Skeleton key={x} height={28} className="mb-1" />;
                })
              ) : (
                <>
                  {sort ? (
                    <Sort
                      sort={sort}
                      desc={desc}
                      updateParams={updateParams}
                      updateSort={updateSort}
                      sortOptions={sortOptions}
                      trending={trending}
                    />
                  ) : null}
                  {dates ? (
                    <div className="filters-section">
                      <div className="date-ranges">
                        <DateRange
                          dates={dates}
                          updateDates={updateDates}
                          filter
                        />
                      </div>
                    </div>
                  ) : null}
                  {dateSelect ? (
                    <div className="filters-section">
                      <div className="date-ranges">
                        <DateSelect date={date} updateDate={updateDate} />
                      </div>
                    </div>
                  ) : null}
                  {updateTrending && !showCampaignHeader && (
                    <FiltersSwitch
                      label="Trending"
                      isChecked={trending}
                      onChange={updateTrending}
                      iconName="trending"
                      disabled={basic}
                    />
                  )}
                  {updateValidEmail && (
                    <FiltersSwitch
                      label="Has Contact"
                      isChecked={validEmail}
                      onChange={updateValidEmail}
                      iconName="email"
                    />
                  )}
                  {updateVyrillVerified && (
                    <FiltersSwitch
                      label="Vyrill Verified"
                      isChecked={vyrillVerified}
                      onChange={updateVyrillVerified}
                      iconName="check"
                      disabled={basic}
                    />
                  )}

                  {filters &&
                    Object.keys(filters)
                      .filter(
                        (i) =>
                          !removedFilters.includes(i) &&
                          !(
                            showCampaignHeader &&
                            hiddenFiltersWhenCampaignHeader.includes(i)
                          )
                      )
                      .map((key) => (
                        <Filter
                          key={key}
                          filters={filters[key]}
                          selectedFilters={selectedFilters[key]}
                          updateFilters={updateFilters(key)}
                          updateSubFilters={
                            updateSubFilters ? updateSubFilters(key) : null
                          }
                          updateParentTopics={updateParentTopics}
                          openFilter={changeFilter(key)}
                          closeFilters={changeFilter("closed")}
                          name={filterNames[key] || key}
                          icon={
                            sentimentReportIcons ? (
                              <Video size={16} />
                            ) : (
                              filterIcons[key] || key
                            )
                          }
                          open={openFilter === key}
                          loading={loading}
                          disabled={basic && proFilters.includes(key)}
                          topicFilters={topicFilters}
                        />
                      ))}

                  {submitButton && (
                    <div
                      style={{ textAlignLast: "center", paddingTop: "15px" }}
                    >
                      <Button
                        color="primary"
                        onClick={() => applyFilters()}
                        variant="contained"
                        disabled={submitStatus}
                        // startIcon={
                        //   submitStatus ? <CircularProgress color="inherit" size={20} /> : <PublishIcon />
                        // }
                      >
                        Apply Filters
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );
};

Filters.defaultProps = {};

Filters.propTypes = {};

export default Filters;
